/** Shared constants of the Portal assistant frontend (spec portal-ai-assistant). */

export const ASSISTANT_DRAWER_ID = 'assistant';
export const ASSISTANT_DRAWER_DEFAULT_SIZE = 380;

/** localStorage: 'open' | 'closed'; absent means the user never toggled it. */
export const DRAWER_STATE_KEY = 'dda-assistant-drawer';
/** sessionStorage: the conversation id reopened after a reload. */
export const CONVERSATION_KEY = 'dda-assistant-conversation';

/** The first-visit rule opens the panel only from this viewport width (Cloudscape `m`). */
export const FIRST_VISIT_MIN_WIDTH = 1120;

export const POLL_INTERVAL_MS = 1000;
export const POLL_INTERVAL_WAITING_MS = 2000;
export const POLL_INTERVAL_HIDDEN_MS = 5000;
/** After this long awaiting a confirmation, polls slow down to the waiting interval. */
export const WAITING_SLOWDOWN_MS = 60_000;
export const STATE_POLL_MS = 30_000;

export const PROMPT_MAX_CHARS = 4000;

export const LIVE_STATUSES = ['queued', 'running', 'awaiting_confirmation'] as const;

/** Where `guide:` citations open when neither config value is set. */
export const DEFAULT_GUIDE_BASE_URL =
  'https://github.com/awslabs/DefectDetectionApplication/blob/main/docs/user-guide';

export const DISCLAIMER = 'Responses are generated by a model. Check them before acting on them.';
